<template>
  <div class="setup-container">
    <div class="progress-bar">
      <div class="progress-side-line progress-active"></div>
      <div class="progress-main">
        <div class="progress-icon progress-active">
          <i class="el-icon-document" />
        </div>
        <div class="progress-content">Step 01</div>
      </div>
      <div class="progress-line progress-active"></div>
      <div class="progress-main">
        <div class="progress-icon progress-active">
          <i class="el-icon-data-analysis" />
        </div>
        <div class="progress-content">Step 02</div>
      </div>
      <div class="progress-line"></div>
      <div class="progress-main">
        <div class="progress-icon">
          <i class="el-icon-bank-card" />
        </div>
        <div class="progress-content">Step 03</div>
      </div>
      <div class="progress-side-line"></div>
    </div>

    <div class="module-grids">
      <div @click="go('Categories')">
        <setup-module-card name="create product categories" :image="categoryImage"/>
      </div>
      <div @click="go('Warehouse')" >
        <setup-module-card name="create warehouses" :image="warehouseImage"/>
      </div>
      <div @click="go('Template')" >
        <setup-module-card name="courier service providers" :image="expressImage"/>
      </div>
      <div @click="go('Brand')">
        <setup-module-card name="create brands" :image="brandImage" @click="go('Brand')" />
      </div>
      <div @click="go('DiscountPlanList')" >
        <setup-module-card name="setup discounts" :image="discountImage"/>
      </div>
      <div @click="go('Management')" >
        <setup-module-card name="create products" :image="goodsImage"/>
      </div>
    </div>
    <div class="action-buttons">
      <div class="back-btn" @click="$emit('go-back')">Back</div>
      <div class="submit-btn" @click="$emit('go-next')">Next</div>
    </div>
  </div>
</template>

<script>
import categoryImage from '@/components/SetupSteps/img/category.png'
import warehouseImage from '@/components/SetupSteps/img/warehouse.png'
import expressImage from '@/components/SetupSteps/img/express.png'
import brandImage from '@/components/SetupSteps/img/brand.png'
import discountImage from '@/components/SetupSteps/img/discount.png'
import goodsImage from '@/components/SetupSteps/img/goods.png'

import SetupModuleCard from '@/components/SetupSteps/SetupModuleCard'

export default {
  name: 'SetupModules',
  components: {
    SetupModuleCard
  },
  data() {
    return {
      categoryImage,
      warehouseImage,
      expressImage,
      brandImage,
      discountImage,
      goodsImage,
      shopName: ''
    }
  },
  created() {
    this.shopName = this.$store.state.shop.display_shop_name
  },
  methods: {
    go(name) {
      this.$router.push({ name })
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.setup-container {
  text-align: center;

  .progress-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px;
    margin-bottom: 60px;

    .progress-active {
      background-color: #95bf47 !important;
    }
    .progress-line {
      flex-basis: 200px;
      height: 1px;
      background: rgba(0, 0, 0, 0.15);
    }
    .progress-side-line {
      flex-basis: 100px;
      height: 1px;
      background: rgba(0, 0, 0, 0.15);
    }
    .progress-main {
      position: relative;

      .progress-icon {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.15);
        i {
          font-size: 24px;
          color: #fff;
        }
      }
      .progress-content {
        position: absolute;
        width: 50px;
        height: 22px;
        bottom: -36px;
      }
    }
  }
  .module-grids {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    width: 960px;
    margin: 0 auto;
    .card {
      margin-bottom: 24px;
    }

    .card:nth-child(2) {
      margin-left: 24px;
      margin-right: 24px;
    }

    .card:nth-child(5) {
      margin-left: 24px;
      margin-right: 24px;
    }
  }
  .action-buttons {
    margin-top: 32px;
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    .back-btn {
      width: 160px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      border: 1px solid rgba(0, 0, 0, 0.15);
      cursor: pointer;
      margin-right: 24px;
    }

    .submit-btn {
      width: 160px;
      height: 40px;
      line-height: 40px;
      background: #95bf47;
      border-radius: 20px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
